/**
 * Sizes available on images, where S1 is the smallest and S5 the largest.
 */
var ImageSizeTypeEnum;
(function (ImageSizeTypeEnum) {
    ImageSizeTypeEnum["S1"] = "S1";
    ImageSizeTypeEnum["S2"] = "S2";
    ImageSizeTypeEnum["S3"] = "S3";
    ImageSizeTypeEnum["S4"] = "S4";
    ImageSizeTypeEnum["S5"] = "S5";
})(ImageSizeTypeEnum || (ImageSizeTypeEnum = {}));
export default ImageSizeTypeEnum;
//# sourceMappingURL=ImageSizeTypeEnum.js.map